import { Grid, Text } from "@mantine/core"
import { differenceInDays } from "date-fns"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

interface Props {
  contact: LibraryResponses.SupplierDetails
}

export const ConnectionCard = ({ contact }: Props) => {
  const { t } = useTranslation("suppliers")
  const lastReminderSentValue = contact.activity.lastReminderDate
    ? t("supplier.lastReminderSentValue", {
        nbDays: differenceInDays(
          new Date(),
          new Date(contact.activity.lastReminderDate)
        ),
      })
    : t("supplier.noLastReminderSent")

  const lastConnectionValue = contact.activity.lastConnectionDate
    ? t("supplier.lastConnectionValue", {
        nbDays: differenceInDays(
          new Date(),
          new Date(contact.activity.lastConnectionDate)
        ),
      })
    : t("supplier.noLastConnection")

  const averageResponseTimeValue = contact.activity.averageResponseTime
    ? t("supplier.averageResponseTimeValue", {
        nbDays: contact.activity.averageResponseTime,
        count: contact.activity.averageResponseTime,
      })
    : t("supplier.noResponseTime")

  return (
    <>
      <Field
        label={t("supplier.lastReminderSent")}
        value={lastReminderSentValue}
      />
      <Field label={t("supplier.lastConnection")} value={lastConnectionValue} />
      <Field
        label={t("supplier.averageResponseTime")}
        value={averageResponseTimeValue}
      />
    </>
  )
}

const Field = ({ label, value }: { label: string; value: string }) => {
  return (
    <Grid>
      <Grid.Col span={6}>
        <Text fw={700}>{label}:</Text>
      </Grid.Col>
      <Grid.Col span={6}>
        <Text>{value}</Text>
      </Grid.Col>
    </Grid>
  )
}
